import React, { useLayoutEffect } from 'react';
import { Paper, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';

import { useRequisites } from './hooks/useRequisites';
import useHomeStyles from '../../../../constants/homeStyles';
import { useFormatMessage } from '../../../../hooks';
import { ButtonWithLoader } from '../../../../components/other/Buttons';
import { setLayoutSubheader } from '../../../../utils/layout';
import Preloader from '../../../../components/other/Preloader/Preloader';
import { IAppState } from '../../../../store/rootDuck';

export function RequisitesPage() {
  const styles = useHomeStyles();
  const me = useSelector((state: IAppState) => state.profile.me);
  const fm = useFormatMessage();
  const { fetchRequisites, loading, requisites, editLoading, editRequisites } =
    useRequisites();

  setLayoutSubheader({
    title: fm('SITE.REQUISITES'),
  });

  const { values, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: {
      inn: requisites?.requisites?.inn || '',
      kpp: requisites?.requisites?.kpp || '',
      ogrn: requisites?.requisites?.ogrn || '',
      legal_address: requisites?.requisites?.legal_address || '',
      post_address: requisites?.requisites?.post_address || '',
      payment_account: requisites?.requisites?.payment_account || '',
      bank: requisites?.requisites?.bank || '',
      bank_bic: requisites?.requisites?.bank_bic || '',
      correspondent_account: requisites?.requisites?.correspondent_account || '',
      owner: requisites?.requisites?.owner || '',
      legal_entity: requisites?.requisites?.legal_entity || '',
      reason: requisites?.requisites?.reason || '',
    },
    enableReinitialize: true,
    onSubmit: values => {
      editRequisites({ requisites: values });
    },
  });

  useLayoutEffect(() => {
    fetchRequisites();
  }, []);
  
  if (!me?.is_admin) return <></>
  if (loading) return <Preloader />;

  return (
    <Paper className={styles.classes.container}>
      <div className={styles.classes.form}>
        <TextField
          type='text'
          label={fm('COMPANY.TABLE.INN')}
          margin='normal'
          name='inn'
          value={values.inn || ''}
          variant='outlined'
          onBlur={handleBlur('inn')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('KPP')}
          margin='normal'
          name='kpp'
          value={values.kpp || ''}
          variant='outlined'
          onBlur={handleBlur('kpp')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('OGRN')}
          margin='normal'
          name='ogrn'
          value={values.ogrn || ''}
          variant='outlined'
          onBlur={handleBlur('ogrn')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('SUBMENU.COMPANY')}
          margin='normal'
          name='legal_entity'
          value={values.legal_entity || ''}
          variant='outlined'
          onBlur={handleBlur('legal_entity')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('LEGAL.ADDRESS')}
          margin='normal'
          name='legal_address'
          value={values.legal_address || ''}
          variant='outlined'
          onBlur={handleBlur('legal_address')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('POST.ADDRESS')}
          margin='normal'
          name='post_address'
          value={values.post_address || ''}
          variant='outlined'
          onBlur={handleBlur('post_address')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('PAYMENT.ACCOUNT')}
          margin='normal'
          name='payment_account'
          value={values.payment_account || ''}
          variant='outlined'
          onBlur={handleBlur('payment_account')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('BANK')}
          margin='normal'
          name='bank'
          value={values.bank || ''}
          variant='outlined'
          onBlur={handleBlur('bank')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('BANK.BIC')}
          margin='normal'
          name='bank_bic'
          value={values.bank_bic || ''}
          variant='outlined'
          onBlur={handleBlur('bank_bic')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('CORRESPONDENT.ACCOUNT')}
          margin='normal'
          name='correspondent_account'
          value={values.correspondent_account || ''}
          variant='outlined'
          onBlur={handleBlur('correspondent_account')}
          onChange={handleChange}
        />
        <TextField
          type='text'
          label={fm('OWNER')}
          margin='normal'
          name='owner'
          value={values.owner || ''}
          variant='outlined'
          onBlur={handleBlur('owner')}
          onChange={handleChange}
        />

        <TextField
          type='text'
          label={fm('REASON')}
          margin='normal'
          name='reason'
          value={values.reason || ''}
          variant='outlined'
          onBlur={handleBlur('reason')}
          onChange={handleChange}
        />
        <div>
          <ButtonWithLoader
            onPress={handleSubmit}
            disabled={editLoading}
            loading={editLoading}
          >
            {fm('COMMON.BUTTON.SAVE')}
          </ButtonWithLoader>
        </div>
      </div>
    </Paper>
  );
}
